const axios = require("axios");
const { GraphServer } = require("@simpleview/sv-graphql-client");
const DamPrefix = require("./prefixes/DamPrefix");

//handles the actual upload through the assets container
async function _uploadFileObject(client, { fileObject, auth}){	
	const response = await axios({
		url : `${client._assetsURL}upload/`,
		method : "post",
		data : {
			auth,
			fileObject
		}
	});

	if (response.data.success === false) {
		throw new Error(response.data.message);
	}

	const data = response.data;

	return {
		success : data.success, 
		message : data.message,
		data : (data.success === true) ? { id : data.data.public_id, type : data.file.type } : {}
	};
};

function DamClient({ graphUrl, assetsUrl }) {
	this._graphServer = new GraphServer({ graphUrl, prefixes : [DamPrefix] });
	this._assetsURL = (assetsUrl !== undefined) ? assetsUrl : 'https://assets.dam.kube.simpleview.io';
};

DamClient.prototype.assets_upsert = async function({ input, fields, context }){
	context = context || this._graphServer.context;
	const fileObject = input.file;
	const uploadResult = await _uploadFileObject(this, {fileObject, auth: context});

	if(uploadResult.success === false){ return { success : false, message : uploadResult.message, doc : null }; }

	const graphQLInput = {
		file_name : fileObject.name,
		file_type : uploadResult.data.type,
		cdn_id : uploadResult.data.id,
		private : (input.private === true) ? true : false
	}

	if( input.id !== undefined ){ graphQLInput['id'] = input.id; }
	const rtn = await this._graphServer.dam.assets_upsert({input : graphQLInput, fields, context});
	return rtn;
}

// convert a file to a fileObject for upload
DamClient.prototype.convertFileToFileObject = async function({ file }){
	if( typeof file !== 'object' ) { return new Error('{File} is not an object.'); }
	if( file.size === undefined || file.name === undefined ) { return new Error('{File} is not a valid file.');  }

	const reader = new FileReader();
	const returnObject = {
		name : file.name,
		length : file.size.toString(),
		dataFormat : 'base64',
		data : [ ]
	};

	return new Promise((resolve, reject) => {
		reader.onerror = () => {
			reader.abort();
			reject(new Error("Unable to parse file data."));
		};

		reader.onload = () => {
			returnObject.data[0] = reader.result;
			resolve(returnObject);
		};

		reader.readAsDataURL(file);
	});
};

module.exports = DamClient;